import { createClient } from 'contentful';

const client = createClient({
  space: 'qoqo41oqgoo1',
  accessToken: 'WoDw-SZTXvzy5EjNSpeagoZ19qZtJja18NyGk4zQ56k',
});

const contentful = {
  client,
};

export default contentful;